import { render } from "./MenuTableCellDeleteRow.vue?vue&type=template&id=22ffa6ea"
import script from "./MenuTableCellDeleteRow.vue?vue&type=script&lang=js"
export * from "./MenuTableCellDeleteRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__